module.exports = __webpack_public_path__ + "static/media/A88.fec29159.jpg";